//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getIcon } from './utils'

export default {
    props: {
        dashboard: Object
    },
    data () {
        return {
            tabs: [
                {
                    key: 'check',
                    link: 'check_condition',
                    icon: getIcon('check'),
                    text: '资格查询'
                },
                {
                    key: 'first_payment',
                    link: 'first_payment',
                    icon: getIcon('first_payment'),
                    text: '测个首付'
                },
                {
                    key: 'provident_fund',
                    link: '/packageB/provident_fund/main',
                    icon: getIcon('provident_fund'),
                    text: '算公积金额度'
                },
                {
                    key: 'computer',
                    link: '/packageA/loan_computer/main',
                    icon: getIcon('computer'),
                    text: '房贷计算'
                },
                {
                    key: 'taxes_calculate',
                    link: '/packageA/taxes_calculate/main',
                    icon: getIcon('taxes_calculate'),
                    text: '税费计算'
                },
                {
                    key: 'prepayment_calc',
                    link: 'prepayment_calc',
                    icon: getIcon('prepayment_calc'),
                    text: '算提前还款'
                },
                {
                    key: 'find_building',
                    link: 'find_building',
                    icon: getIcon('find'),
                    text: '一键找房'
                },
                {
                    key: 'building_rank',
                    link: '/activity_a/building_rank/main',
                    icon: getIcon('building_rank'),
                    text: '楼盘榜单'
                },
                {
                    key: 'house_purchase',
                    link: '/packageA/material/house_purchase',
                    icon: getIcon('house_purchase'),
                    text: '购房指引'
                },
                {
                    key: 'nconv',
                    url: 'https://wx.cdgoufang.com/nconv_map?city=cd',
                    icon: getIcon('nconv'),
                    text: '疫情地图',
                },
                {
                    key: 'inherit',
                    link: 'pages/personal_package/inherit/main',
                    icon: getIcon('inherit'),
                    text: '查房屋继承'
                },
                {
                    key: 'dora',
                    link: 'pages/personal_package/dora/main',
                    icon: getIcon('dora'),
                    text: '查房屋权属'
                },
            ],
            marginLeft: 0,
            slide_bar_width: 0,
            show_slide: false
        }
    },
    mounted() {
        this.checkslide()
        this.getScroll()
    },
    computed: {
        rowIcon() {
            const length = this.tabs?.length
            const cows = Math.ceil(length / 2)
            let data = []
            let index = 0
            for (let i = 0; i < 2; i++) {
                data.push(this.tabs?.slice(index, index+cows))
                index = index + cows
            }
           return data
        },
        dashboard_list () {
            const {
                forthcoming_sale,
                hot,
                latest_lot_number,
                latest_opening,
                surplus
            } = this.dashboard
            return [
                {
                    text: '热门楼盘',
                    key: 'hot',
                    link: '/hot',
                    value: hot
                },
                {
                    text: '即将预售',
                    key: 'forthcoming_sale',
                    link: '/forthcoming_sale',
                    value: forthcoming_sale
                },
                {
                    text: '最新取证',
                    key: 'latest_opening',
                    link: '/list?type=最新取证',
                    value: latest_opening
                },
                {
                    text: '最新摇号',
                    key: 'latest_lot_number',
                    link: '/list?type=最新摇号',
                    value: latest_lot_number
                },
                {
                    text: '在售楼盘',
                    key: 'surplus',
                    link: '/surplus',
                    value: surplus
                }
            ]
        },
    },
    methods: {
        checkslide() {
            const row = document.querySelector('.row')
            if (row?.clientWidth > 375) {
                this.show_slide = true
            }
        },
        getScroll() {
            const { windowWidth } = wx.getSystemInfoSync()
            const ratio = windowWidth / 750
            const slide_width = 40 * ratio
            const tab_width = 750 * ratio
            const { scrollLeft, scrollWidth } = document.querySelector('#scroll')
            this.slide_bar_width = (tab_width / scrollWidth) * slide_width
            const percent = scrollLeft / scrollWidth
            const left = percent * slide_width
            const critical = slide_width - this.slide_bar_width
            this.marginLeft = left < 0 ? 0 : left > critical ? critical : left
        }
    }
}
